module.exports = __webpack_public_path__ + "img/jumbo-stuffed-shells.f4362aa5.jpg";